
const ROUTES = {
	POST_LOGIN: "post-login",
	DASHBOARD: "dashboard",
	OPTIONS: {
		MY_CLASSES: "classes",
		OLD_CLASSES: "old",
		NOTIFICATIONS: "notifications",
		ABOUT: "about",
	},
	ATTENDANCE_IN_PROGRESS_QR_CODE: "attendance-qr",
	ATTENDANCE_IN_PROGRESS_SESSION_CODE: "attendance-session",
	SETTING: "setting",
	ERROR: "invalid-path",
	TERMS: "terms",
	PRIVACY: "privacy",
	CONSENT: "consent",
};

export default ROUTES;
